import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { CareCreditFinancingImage } from '@frontend/payments-assets';
import { breakpoints } from '@frontend/responsiveness';
import { Button, Chip, Heading, Text } from '@frontend/design-system';

const CARE_CREDIT_ARTICLE_LINK = 'https://www.weavehelp.com/weavehelp/article/connecting-and-using-carecredit';

const styles = {
  block: css`
    background-color: var(--fabric-color-neutral-5);
    padding: var(--fabric-space-padding-lg);
  `,
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: calc(var(--fabric-number-n-200-px) + var(--fabric-number-n-19-px));
    margin: 0 auto;

    gap: var(--fabric-space-padding-xl);

    @media (min-width: ${breakpoints.medium.max}px) {
      flex-direction: row;
      align-items: center;
      flex-wrap: nowrap;
    }
  `,
  column: css`
    flex: 1;
    min-width: 0;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: var(--fabric-space-padding-xs);
    max-width: 380px;
    margin: 0 auto;
    order: 2;

    @media (min-width: ${breakpoints.medium.max}px) {
      margin: 0;
      order: 1;
    }
  `,
  imageWrap: css`
    display: flex;
    justify-content: center;
    order: 1;

    @media (min-width: ${breakpoints.medium.max}px) {
      justify-content: flex-end;
      order: 2;
    }
  `,
  button: css`
    width: fit-content;
    margin-top: var(--fabric-space-padding-sm);
  `,
};

export const CareCreditFinancing = () => {
  const { t } = useTranslation('payments');

  return (
    <div css={styles.block} data-testid='care-credit-financing'>
      <div css={styles.container}>
        <div css={[styles.column, styles.imageWrap]}>
          <CareCreditFinancingImage />
        </div>
        <div css={[styles.column, styles.content]}>
          <Chip variant='success' data-testid='care-credit-financing-chip'>
            {t('New Integration')}
          </Chip>
          <Heading level={2} data-testid='care-credit-financing-heading'>
            {t('CareCredit Financing')}
          </Heading>
          <Text data-testid='care-credit-financing-description'>
            {t(
              'Now available in Weave. Give customers the option to pay for treatments while helping you collect payments faster.'
            )}
          </Text>
          <Button
            css={styles.button}
            variant='secondary'
            onClick={() => window.open(CARE_CREDIT_ARTICLE_LINK, '_blank', 'noopener,noreferrer')}
            trackingId='stripe-signup-care-credit-learn-more'
            data-testid='care-credit-financing-learn-more-button'
          >
            {t('Learn More')}
          </Button>
        </div>
      </div>
    </div>
  );
};
